<template>
    <div @mouseover="hover = true"
         @mouseleave="hover = false; pressed = false"
         @mousedown="pressed = true"
         @mouseup="pressed = false;"
         @click.stop="onClick"
         :class="containerClass">
        <div :class="slotClass" class="line-break"><!--
            $ver: v0.1.0
            칩 내부에 위치하는 문자열 입니다.
            #A string located inside the chip.
         --><slot >{{text}}</slot>
        </div>
    </div>
</template>

<script>
    // ur-filter-chip은 문자열과 라운드 처리된 배경으로 이루어져 있으며, 짧고 간략한 정보를 전달하는 데 사용됩니다.
    // #The ur-filter-chip consists of a string and a rounded background, and is used to convey short and brief information.

    export default {

        name: "urFilterChip",
        model: {
            prop: 'checked'
        },
        data() {
            return {
                hover: false,
                pressed: false,
                default:{size: 'medium'}
            };
        },
        inject: {
            urFilterChipWrapper: {from: 'urFilterChipWrapper', default: () => undefined},
            urInput: {from:'urInput', default: () => undefined}
        },
        props: {
            // $ver: v0.2.0
            // $v-model
            // v-model로 바인딩되는 값으로, <em>ur-filter-chip-wrapper</em>를 사용할 경우
            // # Binding to v-model. If <em>ur-filter-chip-wrapper</em> component used,
            // ur-filter-chip-wrapper의 v-model값을 우선시하고 ur-filter-chip의 v-model은 무시됩니다.
            // # v-model of this ur-filter-chip is ignored and v-model of ur-filter-chip-wrapper is used instead.
            // 단일 filter chip으로 사용되는 경우에만 Boolean, String 타입을 사용하고 다중선택이 필요한경우 Array타입을 사용해야 합니다.
            // # Boolean and String type is only used in single filter-chip use-case. Array type has to be set when using multiple select use-case.
            checked: {
                type: [Boolean, String, Array],
            },
            // $ver: v0.2.0
            // 선택되었을 때 v-model의 값으로 설정되는 목표값입니다.
            // # If component is checked, v-model is set as this value.
            // $default: true
            value: {
                type: [String, Boolean, Number, Array, Object],
                default: true
            },

            // $ver: v0.2.0
            // Chip에 표시되는 문자열입니다. <em>slot</em>과 함께 쓰일 경우 <em>slot</em>이 우선순위를 갖습니다.
            // #The string value displayed on the badge. When used with <em>slot</em>, <em>slot</em> have priority.
            // $default: null
            text: {
                type: [String,Number],
                default: null,
            },
            // $ver: v0.2.0
            // 크기 입니다. 'medium','small' 두 가지 중 하나를 입력해야 합니다.
            // #The size You must enter one of two types: medium or small.
            size:{
                type:String,
                default:'medium',
            },

            // $ver: v0.1.2
            // 기본크기 사이즈로 표현합니다.
            // #Expressed in the default size.
            // $default: false
            medium: {type:Boolean, default: false},
            // $abbr: medium
            md: {type:Boolean, default: false},
            // $ver: v0.1.2
            // 작은크기 사이즈로 표현합니다.
            // #Expressed in small size.
            // $default: false
            small: {type:Boolean, default: false},
            // $abbr: small
            sm: {type:Boolean, default: false},

            // $ver: v0.1.0
            // 색상 유형 입니다. 'primary', 'point', 'normal', 'red', 'orange', 'green' 여섯 가지 유형 중 하나를 입력해야 합니다.
            // #The color type. You must enter one of sㅑㅌ types: 'primary', 'point', 'normal', 'red', 'orange', 'green'
            color:{
                type:String,
                default:'normal',
            },

            // $ver: v0.1.0
            // 비활성화 여부입니다. 클릭할 수 없는 상태로 바뀝니다.
            // #Whether to disable It becomes unclickable.
            // $default: false
            disabled:{
                type:Boolean,
                default:false
            },

            // $ver: v0.1.1
            // $hide
            // <em>ur-filter-chip-wrapper</em>와 함께 사용할 때 wrapper 하위에 위치하는 모든 체크박스가 아닌
            // 특정 체크박스에만 validate를 적용하고 싶을 경우 group이름을 지정하여 분리할 수 있습니다.
            // #When used with <em>ur-checkbox-wrapper</em>, you can separate it by specifying the group name
            // #if you want to apply validate only to a specific checkbox rather than to all the checkboxes under the wrapper.
            group: {
                type: String,
                default: 'default'
            }
        },
        computed: {
            isDisabled(){
              if(this.urFilterChipWrapper
                  && this.urFilterChipWrapper[this.group]
                  && this.urFilterChipWrapper[this.group].disabled) {
                return true;
              }else if(this.disabled){
                return true;
              }else{
                return false;
              }
            },
            cSize() {
                if(this.size && (this.size === 'medium' || this.size === 'small')) {
                    return this.size;
                }
                if(this.medium || this.md) return 'medium';
                if(this.small || this.sm) return 'small';
                if(this.urInput) {return this.urInput.size}
                return this.default.size;
            },
            containerClass() {
                return this.isDisabled ? [
                    'ur-filter-chip__container',
                    'ur-filter-chip__container-' + this.cSize,
                    'ur-filter-chip__container-disabled'
                ] : [
                    'ur-filter-chip__container',
                    'ur-filter-chip__container-' + this.cSize,
                    'ur-filter-chip__container-' + this.color + '-filter',
                    this.clicked &&  'ur-filter-chip__container-' + this.color + '-filter-selected',
                ];
            },
            slotClass() {
                return [
                    'ur-filter-chip__slot',
                    this.isDisabled && 'ur-filter-chip__slot-disabled'
                ];
            },
            actualVModel() {
                if(this.urFilterChipWrapper && this.urFilterChipWrapper[this.group]) {
                    if(this.checked){
                        console.warn('[UR-CHECKBOX] if you use ur-filter-chip-wrapper, v-model(=checked props) of ur-filter-chip itself is being ignored.');
                    }
                    return this.urFilterChipWrapper[this.group].checked;
                }
                return this.checked;
            },
            clicked() {
                if (typeof(this.value) == 'boolean') {
                    // Boolean
                    if(this.actualVModel==='Y') return true;
                    if(this.actualVModel==='N') return false;
                    return this.actualVModel;
                }
                else {
                    if (Array.isArray(this.actualVModel)) {
                        // Array
                        return (this.actualVModel.indexOf(this.value) >= 0);
                    }
                    else {
                        // String
                        return this.actualVModel === this.value;
                    }
                }
            },
        },
        methods: {
            onClick(e) {
                // $ver: v0.1.2
                // $arg: click event
                // filter chip 클릭 시 발생하는 이벤트 입니다.
                // # This event occurs when the filter-chip is clicked.
                this.$emit('click',e);
                if(this.urFilterChipWrapper && this.urFilterChipWrapper[this.group]) {
                    this.urFilterChipWrapper[this.group].click(e);
                }

                if (typeof(this.value) === 'boolean') {
                    if(this.actualVModel==='Y') {this.emit('N');}
                    else if(this.actualVModel==='N'){this.emit('Y');}
                    else {
                        this.emit(!this.actualVModel);
                    }
                } else {
                    if (Array.isArray(this.actualVModel)) {
                        if (this.actualVModel.indexOf(this.value) >= 0) {
                            // if exist, remove it
                            this.emit(this.actualVModel.filter(item => item !== this.value));
                        }
                        else {
                            // if not exist, append it
                            this.emit(this.actualVModel.concat(this.value));
                        }
                    }
                    else {
                        // String type v-model
                        this.emit(this.actualVModel===this.value ? '' : this.value);
                    }
                }
            },
            emit(val) {
                if(this.urFilterChipWrapper && this.urFilterChipWrapper[this.group]) {
                    this.urFilterChipWrapper[this.group].emit(val);
                } else {
                    // $ver: v0.1.0
                    // $arg: updated v-model value
                    // v-model에 설정된값(checked)을 업데이트합니다.
                    // # update v-model value(checked props).
                    this.$emit('input', val);
                }
            }
        },
      beforeDestroy() {
        if (typeof(this.value) !== 'boolean') {
          if (Array.isArray(this.actualVModel)) {
            if (this.actualVModel.indexOf(this.value) >= 0) {
              // if exist, remove it
              this.emit(this.actualVModel.filter(item => item !== this.value));
            }
          }
        }
      }
    }
</script>
